import { TECHNOLOGY_REQUIRED_POSITION_IDS } from 'domain/shared/career';
import type { SourcingFilterOptions } from '../../../../types';

const technologyRequiredCondition = {
  value: true,
  when: {
    $specializationId: {
      in: TECHNOLOGY_REQUIRED_POSITION_IDS.flatMap(positionId => [positionId, String(positionId)]),
    },
  },
};

const settingsSourcingDrawerValidationSchema = {
  specializationId: { type: 'enum', required: true },
  technologyId: {
    type: 'string',
    required: technologyRequiredCondition,
  },
};

export const getSettingsSourcingDrawerValidationSchemaFunc = (filterOptions: SourcingFilterOptions) => () =>
  Promise.resolve({
    ...settingsSourcingDrawerValidationSchema,
    specializationId: {
      ...settingsSourcingDrawerValidationSchema.specializationId,
      values: filterOptions.specializations.flatMap(({ specializationId }) => [
        specializationId,
        String(specializationId),
      ]),
    },
  });
